import React, {Component} from 'react';
import {Form, ControlLabel, FormControl} from "react-bootstrap";
import {TopButtonAdd} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";

export default class PokazRozkladDodanieGodzinyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            godzina: '',
            czy_byl_przycisk: false,
        };
        this.onClickDodajKurs = this.onClickDodajKurs.bind(this)
        this.onChangeGodzina = this.onChangeGodzina.bind(this)
    }

    onChangeGodzina(e) {
        this.setState({godzina: e.target.value})
    }

    onClickDodajKurs() {
        this.setState({czy_byl_przycisk: true})
        if (this.state.godzina !== '' && this.state.godzina !== null) {
            this.setState({czy_byl_przycisk: false,godzina:''})
            this.props.handleClickDodajKurs(this.state.godzina)
            document.getElementById('inputGodzinaNowegoKursu').value = ''
        }
    }

    render() {

        return (
            <div className={'pull-right'}>
                <Form inline={true}>
                    <div className={'add-label-margin'}></div>

                    <ControlLabel>Dodaj kurs o:</ControlLabel>
                    <span style={{width: '10px', display: 'inline-block'}}></span>
                    <FormControl type={'time'} id={'inputGodzinaNowegoKursu'} onChange={this.onChangeGodzina}/>
                    <span style={{width: '10px', display: 'inline-block'}}></span>
                    <TopButtonAdd onClick={this.onClickDodajKurs}/>
                </Form>
                <TopIf isTrue={this.state.czy_byl_przycisk && (this.state.godzina === '' || this.state.godzina === null)}>
                <TopAlertUwaga text={'Nie podano godziny'}/>
                </TopIf>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/pokazRozklad/components/PokazRozkladDodanieGodzinyForm.js